import { createContext, useContext, useState, ReactNode } from "react";

import ToastNotification, {
  ToastNotificationVariant
} from "../ToastNotification";

type ToastNotificationContextType = {
  addToastNotification: (content: ToastNotificationContent) => void;
};

type ToastNotificationContent = {
  message: string;
  variant: ToastNotificationVariant;
};

type ToastNotificationProviderProps = {
  children: ReactNode;
};

const ToastNotificationContext = createContext<
  ToastNotificationContextType | undefined
>(undefined);

export const useToast = () => {
  const context = useContext(ToastNotificationContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

function ToastNotificationProvider({
  children
}: ToastNotificationProviderProps) {
  const [toasts, setToasts] = useState<ToastNotificationContent[]>([]);

  const addToastNotification = (content: ToastNotificationContent) => {
    setToasts((prevToasts) => [...prevToasts, content]);
    setTimeout(() => {
      setToasts((prevToasts) => prevToasts.slice(1));
    }, 3000);
  };

  const handleClose = (index: number) => {
    setToasts((prevToasts) => prevToasts.filter((_, i) => i !== index));
  };

  return (
    <ToastNotificationContext.Provider value={{ addToastNotification }}>
      {children}
      <div>
        {toasts.map((notification, index) => (
          <ToastNotification
            key={index}
            message={notification.message}
            variant={notification.variant}
            onClose={() => handleClose(index)}
            className={`${index === 0 ? 'show' : 'hide'}`}
          />
        ))}
      </div>
    </ToastNotificationContext.Provider>
  );
}

export default ToastNotificationProvider;
